import { BASE_API_URL } from "../../config/Api";
import { ADDTIMESHEET_DETAILS, APPROVE_TIMESHEET, CLEAR_TIMESHEET, EDITTIMESHEET_DETAILS, PENDING_TIMESHEET, SENDBACK_TIMESHEET, TIMESHEET_LIST, USER_TIMESHEET_LIST } from "./ActionType";


export const getTimesheetList=(token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/pendingTimeSheet`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:TIMESHEET_LIST, payload:resData})
    } catch (error) {
        
    }
}

export const getUserTimesheetList=(loginId,token,pageNumber,pageSize)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/userTimeSheet?loginId=${loginId}&pageSize=${pageSize}&pageNo=${pageNumber}`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:USER_TIMESHEET_LIST, payload:resData})
    } catch (error) {
        
    }
}

export const addTimesheet=(timesheetData,token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/addUserTimeSheetDetails`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(timesheetData),
        })
        const resData=await res.json();
        if (res.ok && resData.statusCode === "00") {
            dispatch({type:ADDTIMESHEET_DETAILS, payload:resData})
            return { success: true };
          } else {
            return { success: false, error: resData.message || 'An unknown error occurred' };
          }
    } catch (error) {
        console.error("Validation error:", error);
    }
}

export const getTimesheetEditData=(timesheetId,token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/getTimeSheetEdit?timesheetId=${timesheetId}`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:EDITTIMESHEET_DETAILS, payload:resData})
    } catch (error) {
        
    }
}

export const clearTimesheet = () => {
    return {
        type: CLEAR_TIMESHEET,
    };
};

export const getPendingTimesheetData=(loginId,fromDate,toDate,type,token,pageNumber,pageSize)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/timesheetMngList?loginId=${loginId}&fromDate=${fromDate}&toDate=${toDate}&type=${type}&pageSize=${pageSize}&pageNo=${pageNumber}`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:PENDING_TIMESHEET, payload:resData})
    } catch (error) {
        
    }
}

export const approveTimesheet=(timeSheetId,rating,token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/approveTimeSheet?timeSheetId=${timeSheetId}&rating=${rating}`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        if (res.ok && resData.statusCode === "00") {
            dispatch({type:APPROVE_TIMESHEET, payload:resData})
            return { success: true };
          } else {
            return { success: false, error: resData.message || 'An unknown error occurred' };
          }
    } catch (error) {
        console.error("Validation error:", error);
    }
}

export const sendBackTimesheet=(timeSheetId,msg,token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/sendBackTimeSheet?timeSheetId=${timeSheetId}&msg=${msg}`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        if (res.ok && resData.statusCode === "00") {
            dispatch({type:SENDBACK_TIMESHEET, payload:resData})
            return { success: true };
          } else {
            return { success: false, error: resData.message || 'An unknown error occurred' };
          }
    } catch (error) {
        console.error("Validation error:", error);
    }
}